export function SuccessIcon({
  className,
  color = "#4E9E52",
}: {
  className?: string;
  color?: string;
}) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0 9.75C0 4.365 4.365 0 9.75 0C15.135 0 19.5 4.365 19.5 9.75C19.5 15.135 15.135 19.5 9.75 19.5C4.365 19.5 0 15.135 0 9.75ZM13.523 6.442C13.4431 6.3842 13.3526 6.34273 13.2567 6.31994C13.1608 6.29715 13.0613 6.2935 12.964 6.3092C12.8666 6.32489 12.7733 6.35963 12.6894 6.41142C12.6055 6.4632 12.5327 6.53102 12.475 6.611L8.878 11.592C8.85597 11.6225 8.82734 11.6476 8.79424 11.6655C8.76114 11.6834 8.72443 11.6936 8.68684 11.6953C8.64926 11.6971 8.61177 11.6903 8.57716 11.6755C8.54256 11.6607 8.51174 11.6383 8.487 11.61L6.981 9.89C6.91697 9.81326 6.83824 9.7501 6.74946 9.70422C6.66067 9.65834 6.5636 9.63066 6.46397 9.62282C6.36433 9.61499 6.26414 9.62714 6.16926 9.65857C6.07439 9.69001 5.98676 9.74009 5.91152 9.80587C5.83627 9.87164 5.77494 9.9518 5.73111 10.0416C5.68728 10.1314 5.66185 10.2291 5.6563 10.3289C5.65076 10.4287 5.66521 10.5286 5.69882 10.6227C5.73243 10.7168 5.78451 10.8033 5.852 10.877L7.358 12.598C7.53134 12.7961 7.74715 12.9526 7.98935 13.0558C8.23155 13.1589 8.4939 13.2061 8.75687 13.1938C9.01983 13.1815 9.27664 13.11 9.50815 12.9847C9.73966 12.8594 9.93991 12.6834 10.094 12.47L13.691 7.49C13.7488 7.41018 13.7904 7.31974 13.8133 7.22385C13.8361 7.12796 13.8399 7.02851 13.8243 6.93117C13.8087 6.83384 13.774 6.74053 13.7223 6.6566C13.6706 6.57266 13.6029 6.49974 13.523 6.442Z"
        fill={color}
      />
    </svg>
  );
}
